<template>
<div class="text-xs-center">

<v-dialog persistent v-model="groups.modals.deleteSelected" width="500">

<v-card>

<v-toolbar dark  color="red" flat  height="42">
<v-toolbar-title  > Удаление   из списка активности  </v-toolbar-title>
<v-spacer></v-spacer>
<v-icon @click="cancel()">mdi-close</v-icon>
</v-toolbar>

<v-card-text scrollable>
Вы действительно хотите удалть {{groups.selected.length}}   из списка активности? отменить данное
действие будет невозможно

<div>
  <v-checkbox v-model="groups.deleteParams.deleteSavedFollowers"  hide-details  color="#232F3A"  >
  <span style="color:#232F3A;margin-top:6px" slot="label">Удалить запомненные подписки</span>
  </v-checkbox>

  <v-checkbox v-model="groups.deleteParams.toBlackList.is" hide-details  color="#232F3A"  >
  <span style="color:#232F3A;margin-top:6px" slot="label">Добавить в черный список</span>
  </v-checkbox>

  <v-text-field v-if="groups.deleteParams.toBlackList.is" v-model="groups.deleteParams.toBlackList.reasonText" solo placeholder="Опишите причину почему в ЧС"></v-text-field>
</div>

</v-card-text>

<v-divider></v-divider>

<v-card-actions>
<v-spacer></v-spacer>
<v-btn style="text-transform:none" color="#4A76A8" small flat @click="cancel()">
Отмена
</v-btn>

<v-btn style="text-transform:none" color="red" small class="white--text" @click="ok()">
Удалить
</v-btn>
</v-card-actions>
</v-card>

</v-dialog>

</div>
</template>




<script>
import axios from 'axios'
export default {
props: [ 'groups'],
 data: function(){
  return {

  }
},

methods: {
 ok: function(){
    this.groups.q = '!deleteSelected'
    this.groups.modals.deleteSelected = false
 },
 cancel: function(){
   this.groups.modals.deleteSelected = false
 }

}
}
</script>

<style  >

</style>
